import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { StatsBar } from "@/components/landing/StatsBar";
import { Marquee } from "@/components/landing/Marquee";
import { Services } from "@/components/landing/Services";
import { Process } from "@/components/landing/Process";
import { WhyUs } from "@/components/landing/WhyUs";
import { FormsSection } from "@/components/landing/FormsSection";
import { Contact } from "@/components/landing/Contact";
import { Footer } from "@/components/landing/Footer";
import { WhatsAppFloat } from "@/components/landing/WhatsAppFloat";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="relative bg-[#0a0f1d] min-h-screen">
      <div className="grain-overlay" />
      <Header />
      <Hero />
      <Marquee />
      <StatsBar />
      <Services />
      <Process />
      <WhyUs />
      <Marquee />
      <FormsSection />
      <Contact />
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
